import { AppShell } from '@/components/layout/AppShell';
import { legalDocument, type LegalSlug } from '@/features/legal/documents';
import { LegalDocumentView } from '@/features/legal/LegalDocumentView';
import { paths } from '@/routes/paths';

export interface LegalPageProps {
  slug: LegalSlug;
}

/**
 * One route, five documents. The slug comes from the route table rather than
 * from useParams so that each policy keeps its own real URL — `/privacy`, not
 * `/legal/:slug` — which is what a payment gateway's onboarding form and a
 * search engine both want.
 *
 * `backTo` gives the customer a way out that is not the browser's back button:
 * these pages are routinely arrived at from an external link — a payment
 * gateway's listing, an email — where back leaves the site entirely.
 */
export function LegalPage({ slug }: LegalPageProps) {
  const doc = legalDocument(slug);

  return (
    <AppShell title={doc.title} backTo={paths.home} backLabel="Home">
      <LegalDocumentView doc={doc} />
    </AppShell>
  );
}
